import { abbreviateNames } from "~/utils/string";

export default abbreviateNames;
